import React, { Component } from 'react'

import Calendar from 'rc-calendar'
import 'rc-calendar/assets/index.css'

import DatePicker from 'rc-calendar/lib/Picker'
import koKR from 'rc-calendar/lib/locale/ko_KR'

import moment from 'moment'
import 'moment/locale/ko'
const format = 'YYYY-MM-DD'

const now = moment()

const defaultCalendarValue = now.clone()
defaultCalendarValue.add(-1, 'month')

class CalendarView extends Component {
  state = {
    open: true,
    destroy: false,
  }

  getCalendarContainer() {
    return this.d || document.getElementById('d')
  }

  setVisible(open) {
    this.setState({
      open,
    })
  }

  open = () => {
    this.setVisible(true)
  }

  close = () => {
    this.setVisible(true)
  }

  destroy = () => {
    this.setState({
      destroy: true,
    })
  }

  render() {
    if (this.state.destroy) {
      return null
    }
    return (
      <React.Fragment>
        <DatePicker calendar={<Calendar locale={koKR} />}>
          {({ value }) => {
            let flag = this.props.default === null
            let defaultValue = flag ? '' : this.props.default ? this.props.default : value?.format(format) ? value?.format(format) : ''

            // console.log('############################################### 캘린더 시작')
            // console.log('value', value)
            // console.log('title', this.props.title)
            // console.log('flag', flag)
            // console.log('selected Value:', value?.format(format))
            // console.log('default', this.props.default)
            // console.log('defaultValue', defaultValue)
            // console.log('############################################### 캘린더 종료')

            return (
              <input
                className="form-control w130"
                placeholder="날짜"
                defaultValue={defaultValue}
                onSelect={() => this.props.onSelect(flag ? '' : value)}
                title={this.props.title ? this.props.title : '날짜'}
                id={this.props.id}
              />
            )
          }}
        </DatePicker>
      </React.Fragment>
    )
  }
}

export default CalendarView
